import { useEffect, useMemo } from 'react'
import { useLocation } from 'react-router-dom'

const STORAGE_KEY = 'wps.lastMechanicalProjectId'

const MECH_PATH = /^\/projects\/([^/]+)\/mechanical-tests(\/.*)?$/

/**
 * Project id for global shortcuts: prefers id from the mechanical-tests URL,
 * otherwise last id stored while visiting mechanical routes.
 */
export function useLastMechanicalProjectId(): string | null {
  const { pathname } = useLocation()

  const idFromUrl = useMemo(() => {
    const m = pathname.match(MECH_PATH)
    return m?.[1] ?? null
  }, [pathname])

  useEffect(() => {
    if (!idFromUrl) return
    try {
      sessionStorage.setItem(STORAGE_KEY, idFromUrl)
    } catch {
      /* ignore quota / private mode */
    }
  }, [idFromUrl])

  if (idFromUrl) return idFromUrl

  try {
    return sessionStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}
